import { DateString } from "@pentacode/openapi";
import { DateRange } from "../time";

export function getAllContractsForRange<T extends { start: DateString; end: DateString | null }>(
    contracts: T[],
    { from, to }: DateRange
) {
    // TODO: this mutates the original array, which is not ideal.
    contracts.sort((a, b) => (a.start < b.start ? -1 : 1));
    return contracts.filter((c) => {
        return c.start < to && (!c.end || c.end > from);
    });
}

export function getContractForRange<T extends { start: DateString; end: DateString | null }>(
    contracts: T[],
    range: DateRange
): T | null {
    return getAllContractsForRange(contracts || [], range)[0] || null;
}

export function getContractForDate<T extends { start: DateString; end: DateString | null }>(
    contracts: T[],
    date: DateString
): T | undefined {
    return contracts.find((c) => c.start <= date && (!c.end || c.end > date));
}
